import React, {useState, useEffect} from 'react';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.min.css';
import './toastAlert.css'
import { t } from "i18next";
export const toastAlert = (message, extra, errorType) => {
    toast.configure({
        position: toast.POSITION.BOTTOM_RIGHT,
        limit: 3,
        autoClose: 3500,
        closeOnClick: true,
    });
    let component = <></>
    const Component = (props) => {
        const [messageState, setMessageState] = useState(props.message)
        useEffect(() => {
            setMessageState(props.message)
        }, [props.message])
        return (
        <span style={{fontFamily:'Tajawal'}}>
            <span>{messageState}</span><br />
        </span >
        )
    };
    try {

        component = (
            <Component message={message}/>
            );
    } catch (error) {
        toastAlert(t("Something went wrong...!"), undefined, "error")
    }
    switch (errorType) {
        case "warning":
            if (Array.isArray(message)) {
            message.map(item => toast.warn(t(item)));
            } else {
                toast.warn(t(message))
            }
            break;
        case "error":
            toast.error(t(message));
            break;
        case "success":
            toast.success(t(message));
            break;
        default:
            toast.info(t(message));
            break;
    }
    toast.clearWaitingQueue();
};
